import axios from "axios";


const GetBankList = async () => {
  return axios.get(`BankDetails/GetBanks`).then((response) => response);
};


const AddBank = async (payload) => {
  const config = {
    method: "post",
    url: `BankDetails/AddBank`,
    headers: { "Content-Type": "application/json" },
    data: payload,
  };
  return axios.request(config).then((response) => response);
};


const UpdateBank = async (payload) => {
  const config = {
    method: "post",
    url: `BankDetails/UpdateBank`,
    headers: { "Content-Type": "application/json" },
    data: payload,
  };
  return axios.request(config).then((response) => response);
};

const bankService = {
  GetBankList,
  AddBank,
  UpdateBank,
};

export default bankService;
